import * as React from "react";
import { SVGProps } from "react";
const SvgEuro = (props: SVGProps<SVGSVGElement>) => (
  <svg
    id="Euro_svg__Ebene_1"
    data-name="Ebene 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    {...props}
  >
    <defs>
      <style>{".Euro_svg__cls-1{fill:none}"}</style>
    </defs>
    <path d="M27.5 40.52c-9.11 0-16.52-7.41-16.52-16.52v-.17c.1-9.02 7.51-16.35 16.52-16.35 3.13 0 6.18.88 8.8 2.54l-1.61 2.53a13.397 13.397 0 0 0-7.2-2.08c-7.37 0-13.44 6-13.52 13.37v.15c0 7.46 6.06 13.52 13.52 13.52 2.57 0 5.06-.72 7.22-2.09l1.61 2.54a16.471 16.471 0 0 1-8.82 2.55Z" />
    <path d="m25.69 26.76-1.9 3H8v-3h17.69zM31.09 18.24l-1.9 3H8v-3h23.09z" />
    <path
      className="Euro_svg__cls-1"
      d="m25.69 26.76-1.9 3M31.09 18.24l-1.9 3"
    />
  </svg>
);
export default SvgEuro;
